<script setup>
import { ref } from 'vue'
import accountForm from '../components/accountForm.vue'
import DiscordForm from '../components/discordForm.vue'
import premiumCard from '../components/premiumCard.vue'
import gameSettingsForm from '../components/gameSettingsForm.vue'
import {
    DriverStore
} from '../pinia/Driver.js'
const Driver = DriverStore()

var dialog = ref(false)
var model = ref()
</script>

<template>

<v-btn
    @click="dialog = true"
        id="menu"
        icon="mdi-cog">
    </v-btn>

  <v-dialog transition="dialog-bottom-transition" :width="500" v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark color="primary" class="settings-toolbar">
        <v-icon class="mr-2">mdi-cog</v-icon>
        <div class="toolbar-content">
          <v-toolbar-title class="toolbar-main-title">Settings</v-toolbar-title>
          <div class="toolbar-subtitle">Manage your account and preferences</div>
        </div>
        <v-spacer></v-spacer>

        <template v-slot:extension>
          <v-tabs v-model="model" centered>
            <v-tab value="1">
              <v-icon class="mr-2" size="small">mdi-account</v-icon>
              Account
            </v-tab>
            <v-tab value="2">
              <v-icon class="mr-2" size="small">mdi-gamepad-variant</v-icon>
              Game Settings
            </v-tab>
            <v-tab value="3">
              <v-icon class="mr-2" size="small">mdi-discord</v-icon>
              Discord
            </v-tab>
            <v-tab value="4">
              <v-icon class="mr-2" size="small">mdi-crown</v-icon>
              Premium
            </v-tab>
          </v-tabs>
        </template>

      </v-toolbar>

      <v-window v-model="model">
        <v-window-item value="1">
          <v-card>
            <v-card-text>
              <accountForm />
            </v-card-text>
          </v-card>
        </v-window-item>
        <v-window-item value="2">
          <v-card>
            <v-card-text>
              <gameSettingsForm />
            </v-card-text>
          </v-card>
        </v-window-item>
        <v-window-item value="3">
          <v-card>
            <v-card-text>
              <DiscordForm />
            </v-card-text>
          </v-card>
        </v-window-item>
        <v-window-item value="4">
          <v-card>
            <v-card-text>
              <premiumCard />
            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>

    </v-card>
  </v-dialog>
</template>
<style>
.v-list-item__prepend {
  font-size: 30px!important;
  margin-top: 10px;
}
</style>
<style scoped>

#menu {
  margin-bottom: 10px!important;
}

.downloadbtn {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

span {
  margin: 0 0px;
}

button {
  margin: initial !important;
}

/* Toolbar Styles */
.settings-toolbar {
  padding: 8px 16px !important;
}

.toolbar-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.toolbar-main-title {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
}

.toolbar-subtitle {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1;
}
</style>

<style>
.v-list-item-title {
  margin: 10px 0 !important;
}
</style>